import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemLog } from 'src/app/models/domain';
import { ItemLogAdapter } from 'src/app/models/domain/adapters';
import { ItemlogSetService, YPMITEMLOGSRVItemlog } from 'src/generated-clients/itemlog';

@Injectable({
  providedIn: 'root',
})
export class ItemLogDataService {
  private readonly materialNumberPropertyName: keyof YPMITEMLOGSRVItemlog = 'materialNumber';

  public constructor(
    private readonly itemLogService: ItemlogSetService,
    private readonly itemLogAdapter: ItemLogAdapter
  ) {}

  public getItemLogsByDesignId(designId: string): Observable<ItemLog[]> {
    // materialNumber is designId in ItemLog, it's not a mistake!
    const filter = `${this.materialNumberPropertyName} eq '${designId}'`;

    return this.itemLogService.itemlogSetGet(undefined, undefined, filter).pipe(
      rethrowAsSapError(),
      map((res) => {
        if (!res.d?.results) {
          throw new Error('SAP Error');
        }

        return res.d.results.map((log) => this.itemLogAdapter.adaptToDomain(log));
      })
    );
  }
}
